import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { ShowcaseComponent } from 'src/app/features/showcase/component/showcase/showcase.component';
import { MyTicketsComponent } from '../my-tickets/my-tickets.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() secNavOpen: boolean = false;
  @Input() primaryNavTemplate: TemplateRef<any>;
  primaryNav: TemplateRef<any>;
  @Output() searchcriteria = new EventEmitter();
  @ViewChild(ShowcaseComponent) showcaseComponent: ShowcaseComponent;
  searchIcon: any = 'assets/images/cinejoy/Search.png';
  isShowSearchIcon: boolean = true;
  secondaryNav = false;
  togglecart = true;
  show: false;
  @Input() showHeader: boolean = true;
  isLoginButtonDisabled = false;
  userInfo: any;
  showCloseIcon: boolean = false;
  isShowXIcon: boolean;
  isShowSearchBar: boolean;
  searchText: any = '';
  symposiums = false
  agilePurchaseEnabled:boolean=environment.agilePurchaseEnabled;
  @Output() secondarySideNavStatus = new EventEmitter();
  @Output() searchbarClosed = new EventEmitter();
  @Output() hideSelectedCategory = new EventEmitter();
  @Output() selectedCategory = new EventEmitter();
  @Input() awardsSelectedCategory: any = 0;
  constructor(private modalService: NgbModal, public router: Router, private service: AuthenticationService) { }

  ngOnInit(): void {
    if (this.router.url.includes('symposiums')) {
      this.symposiums = true
    }
    else {
      this.symposiums = false
    }
    console.log(this.awardsSelectedCategory)
    this.awardsSelectedCategory = 0;
    this.primaryNav = this.primaryNavTemplate;
    if (this.secNavOpen) {
      this.secondaryNav = true;
      this.toggleNav(true);
    }
    if (this.router.url.includes('/showcase/moviepage/') || this.router.url.includes('/showcase/archive/moviepage/')) {
      this.showCloseIcon = true;
    }
    this.service.checkUserAuthenticated().subscribe(
      data => {

        this.userInfo = data.userId;
        console.log(this.userInfo);
        if (this.userInfo <= 0) {
          this.isLoginButtonDisabled = true;
        }
        else {
          this.isLoginButtonDisabled = false;
        }
      })

  }

  close() {
    this.secondaryNav = false
  }

  toggleNav(flag: boolean): void {
    this.secondaryNav = flag;
    this.togglecart = !this.togglecart;
    this.isShowSearchIcon = false;
    if(!flag){
      this.isShowSearchIcon = true;
    }
    if(flag){
      this.isShowSearchIcon = false;
      this.isShowXIcon = false;
    }
    if(this.isShowSearchBar && !flag){
      this.isShowSearchIcon = false;
      this.isShowXIcon = true;
      this.HideSearchBar()
    }
    //this.secondarySideNavStatus.emit(false);
  }
  searchThis() {
    this.searchcriteria.emit(this.searchText);
  }
  ShowSearchBar() {
    this.isShowSearchIcon = !this.isShowSearchIcon;
    this.isShowXIcon = true;
    this.isShowSearchBar = true;

  }
  HideSearchBar() {
    this.isShowXIcon = !this.isShowXIcon;
    this.isShowSearchIcon = true;
    this.searchText = '';
    this.isShowSearchBar = false;
    this.searchbarClosed.emit()
  }

  openMyTicket(): void {
    const modalRef = this.modalService.open(MyTicketsComponent, { size: 'lg', backdrop: 'static' });
  }

  navigateToUpcoming() {
    this.router.navigate(['/cinejoy/premiere/lineup']);
  }

  navigateToShowcase() {
    this.close()
    this.hideSelectedCategory.emit(true);
  }

  navigateToShowcaseArchive() {
    this.secondarySideNavStatus.emit(true);
    this.router.navigate(['/cinejoy/showcase/archive']);
  }

  checkMovieInfo(url) {
    if (url.includes('/cinejoy/showcase/movie-info')) {
      return true
    } else {
      return false;
    }
  }

  selectedCategoryEmit(event: any) {
    this.awardsSelectedCategory = event;
    this.selectedCategory.emit(event);
  }
}
